<template>
    <!--
      v-menu (not v-tooltip) so the pointer can move into the list and scroll
      without the overlay closing in the gap between activator and content.
    -->
    <v-menu
        v-if="names?.length"
        open-on-hover
        :open-delay="150"
        :close-delay="200"
        location="top"
        :offset="6"
        content-class="count-names-menu"
        transition="fade-transition"
    >
        <template #activator="{ props }">
            <span
                v-bind="props"
                class="tooltip-count tooltip-count--interactive"
                @click.stop
            >
                {{ count }}
            </span>
        </template>
        <div
            class="tooltip-list"
            :class="{ 'tooltip-list--columns': useColumns }"
            @wheel.stop
        >
            <div
                v-for="(name, index) in names"
                :key="`${index}-${name}`"
                class="tooltip-list__item"
            >
                {{ name }}
            </div>
        </div>
    </v-menu>
    <span v-else class="tooltip-count">{{ count }}</span>
</template>

<script>
/**
 * Shows a numeric count; on hover, lists related names.
 * Long lists scroll; 21+ names use two columns so they stay readable.
 * Shared by Statistics tables and TeamLeadersTable.
 */
export default {
    name: "CountWithNamesTooltip",
    props: {
        count: { type: [Number, String], required: true },
        names: { type: Array, default: () => [] },
    },
    computed: {
        useColumns() {
            return (this.names || []).length > 20;
        },
    },
};
</script>

<style scoped>
.tooltip-count {
    cursor: default;
}
.tooltip-count--interactive {
    cursor: pointer;
}
</style>

<!-- Menu content is teleported to <body>; needs a global class. -->
<style>
.count-names-menu {
    background: rgba(33, 33, 33, 0.92) !important;
    color: #fff !important;
    border-radius: 6px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28) !important;
    padding: 8px 10px !important;
    max-width: min(92vw, 420px) !important;
    overflow: hidden !important;
}

.count-names-menu .tooltip-list {
    max-height: min(50vh, 320px);
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
    text-align: left;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.35) transparent;
}

.count-names-menu .tooltip-list::-webkit-scrollbar {
    width: 4px;
}

.count-names-menu .tooltip-list::-webkit-scrollbar-track {
    background: transparent;
}

.count-names-menu .tooltip-list::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.35);
    border-radius: 4px;
}

.count-names-menu .tooltip-list--columns {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 1.25rem;
    min-width: min(92vw, 360px);
}

.count-names-menu .tooltip-list__item {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.35;
    padding: 1px 0;
    font-size: 0.8125rem;
}
</style>
